// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getLoyaltyTierBenefits } from '@tcp/core/src/services/abstractors/SFCC/getLoyaltyTierBenefits';
import { getIsGuest } from '@tcp/core/src/components/features/account/User/container/User.selectors.js';
import { isCanada } from '@tcp/core/src/utils';
import Abstractor from '@tcp/core/src/services/abstractors/common/loyaltyTierBenefit';
import LOYALTY_PLACE_REWARDS_CONSTANTS from '../LoyaltyPlaceRewards.constants';
import {
  setLoyaltyTierBenefits,
  fetchLoyaltyBenefitJsonSuccess,
  fetchLoyaltyBenefitJsonFailure,
} from './PlaceRewards.actions';
import { getLoyaltyTierBenefitJson } from './PlaceRewards.selectors';

const REFRESH_THRESHOLD = 1 * 60 * 1000; // 1 minute in milliseconds

export function* getTierBenefits({ payload }) {
  const guestUser = yield select(getIsGuest);
  const loyaltyTierBenefitsRes =
    !guestUser && !isCanada() ? yield call(getLoyaltyTierBenefits, payload) : [];
  yield put(setLoyaltyTierBenefits(loyaltyTierBenefitsRes?.benefits));
}

export function* fetchLoyaltyTierBenefitJsonSaga() {
  try {
    const existingBenefitData = yield select(getLoyaltyTierBenefitJson);
    const currentTime = new Date().getTime();

    if (
      existingBenefitData?.data?.length &&
      existingBenefitData?.timestamp &&
      currentTime - existingBenefitData.timestamp < REFRESH_THRESHOLD
    ) {
      return;
    }

    const newBenefitsData = yield call(Abstractor.getLoyaltyTierBenefitData, 'tier_benefits');
    yield put(fetchLoyaltyBenefitJsonSuccess(newBenefitsData));
  } catch (error) {
    logger.error('Error fetching Loyalty Benefit Json:', error);
    yield put(fetchLoyaltyBenefitJsonFailure(error));
  }
}

export function* LoyaltyPlaceRewardsSaga() {
  yield takeLatest(LOYALTY_PLACE_REWARDS_CONSTANTS?.GET_TIER_BENEFITS, getTierBenefits);
  yield takeLatest(
    LOYALTY_PLACE_REWARDS_CONSTANTS?.FETCH_LOYALTY_BENEFIT_JSON_REQUEST,
    fetchLoyaltyTierBenefitJsonSaga
  );
}

export default LoyaltyPlaceRewardsSaga;
